import { configureApiEntity } from '../adapter/index';
import { schema } from 'normalizr';

export const productGroupsSchema = new schema.Entity('productGroups');
export const productGroups = configureApiEntity('PRODUCTGROUPS', 'productGroups', productGroupsSchema);
